export interface AutomationDefinitionPreTurnOnMeta {
  existingMatchingCount: number;
  allMatchingCount: number;
}

export interface AutomationRunningInstancesResponse {
  count: number;
}

export enum AutomationExternalTaskProcessingQueueReason {
  AUTOMATION_OFF = "AUTOMATION_OFF",
  CREDIT_INSUFF = "CREDIT_INSUFF",
  BUDGET_INSUFF = "BUDGET_INSUFF",
  EMAIL_PO_INSUFF = "EMAIL_PO_INSUFF",
  POSTCARD_PO_INSUFF = "POSTCARD_PO_INSUFF"
}

export interface AutomationDefinitionCountResponse {
  existingMatchingCount: number;
  allMatchingCount: number;
}

export const AutomationExternalTaskProcessingQueueReasonLabel: Record<AutomationExternalTaskProcessingQueueReason, string> = {
  AUTOMATION_OFF: "Automation Off",
  CREDIT_INSUFF: "Insufficient Credits",
  BUDGET_INSUFF: "Limit Exhausted",
  EMAIL_PO_INSUFF: "Daily sending limit reached",
  POSTCARD_PO_INSUFF: "Limit Exhausted"
};

export interface AutomationPendingContactWrapper {
  contactId: string;
  propertyId?: string;
  processId: string;
  completionDueDate?: Date;
  queueReason: AutomationExternalTaskProcessingQueueReason;
}
